module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column centered-start modal-overlay"
  }, [_c('div', {
    staticClass: "column all-start cotacao-itens-main-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(!_vm.abrirCotacaoPrecos && !_vm.abrirDetalheItem && !_vm.abrirCotacaoManual) ? _c('div', {
    staticClass: "box-body column centered-start cotacao-itens-container"
  }, [_c('div', {
    staticClass: "row-flex centered-start cotacao-header-container"
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" [" + _vm._s(_vm.idProposta) + "] "), _c('i', [_vm._v("#" + _vm._s(_vm.idCotacao))]), _vm._v(" Resumo da cotação\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-between cotacao-adicionar-container"
  }, [_vm._m(0), _vm._v(" "), (this.itensCotacaoManual.length !== 0 || this.itensCotacao.length !== 0 && !_vm.validandoCotacao) ? _c('div', [(this.itensCotacaoManual.length === 0 && !_vm.visualizandoCotacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "title": "Abre o Busca Preço, sistema de banco de dados de preços de Licitações."
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleAdicionarItem(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cotação Automática ")]) : _vm._e(), _vm._v(" "), (this.itensCotacao.length === 0 && !_vm.visualizandoCotacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "title": "Não encontrou o item desejado, ou conseguiu um preço melhor? Cadastre aqui."
    },
    nativeOn: {
      "click": function($event) {
        return _vm.novaCotacaoManual(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cotação Manual ")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.showTable),
      expression: "loading.showTable"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none",
      "background": "rgba(255, 255, 255, 0.7)",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "position": "absolute",
      "font-size": "30px"
    }
  })]), _vm._v(" "), (this.itensCotacaoManual.length === 0 && this.itensCotacao.length === 0) ? _c('div', {
    staticClass: "descricao-cotacao-container column all-centered gap-5"
  }, [_c('div', {
    staticClass: "row-flex all-centered w-100 gap-5"
  }, [(this.itensCotacaoManual.length === 0) ? _c('div', {
    staticClass: "row-flex all-centered button-cotacao button-azul",
    attrs: {
      "title": "Abre o Banco de Cotações, sistema de banco de dados de preços de Licitações."
    },
    on: {
      "mouseover": function($event) {
        _vm.textoInstrucao = 'Abre o Busca Preço, sistema de banco de dados de preços de Licitações.'
      },
      "mouseleave": function($event) {
        _vm.textoInstrucao = 'Selecione uma opção para começar o cadastro da cotação.'
      },
      "click": function($event) {
        return _vm.toggleAdicionarItem(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cotação Automática ")]) : _vm._e(), _vm._v(" "), (this.itensCotacao.length === 0) ? _c('div', {
    staticClass: "row-flex all-centered button-cotacao button-amarelo",
    attrs: {
      "title": "Não encontrou o item desejado, ou conseguiu um preço melhor? Cadastre aqui."
    },
    on: {
      "mouseover": function($event) {
        _vm.textoInstrucao = 'Não encontrou o item desejado, ou conseguiu um preço melhor? Cadastre aqui.'
      },
      "mouseleave": function($event) {
        _vm.textoInstrucao = 'Selecione uma opção para começar o cadastro da cotação.'
      },
      "click": function($event) {
        return _vm.novaCotacaoManual(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cotação Manual ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-centered gap-10 cotacao-texto-instrucao"
  }, [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v(" " + _vm._s(_vm.textoInstrucao) + "\n        ")])]) : _vm._e(), _vm._v(" "), (this.itensCotacaoManual.length !== 0 || this.itensCotacao.length !== 0) ? _c('div', {
    staticClass: "descricao-cotacao-container"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descricaoCotacao),
      expression: "descricaoCotacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Descrição da Cotação (Será gerada automaticamente, mas você pode editar)",
      "disabled": _vm.validandoCotacao
    },
    domProps: {
      "value": (_vm.descricaoCotacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descricaoCotacao = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (this.itensCotacaoManual.length > 0 || this.itensCotacao.length > 0) ? _c('div', {
    staticClass: "column all-centered cotacao-table-container"
  }, [(this.itensCotacaoManual.length === 0) ? _c('b-container', {
    staticClass: "w-100",
    attrs: {
      "fluid": ""
    }
  }, [_c('label', [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v("  Banco de Cotações:\n                ")]), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [(!_vm.validandoCotacao) ? _c('g-button-ujarak', {
          directives: [{
            name: "confirm",
            rawName: "v-confirm",
            value: ({
              ok: function (retorno) { return _vm.removerItem(row.item); },
              cancel: _vm.doNothing,
              message: 'Confirma Exclusão do Produto/Serviço: ' + row.item.descricao + ' ?'
            }),
            expression: "{ok: retorno => removerItem(row.item), cancel: doNothing,\n                              message: 'Confirma Exclusão do Produto/Serviço: ' + row.item.descricao + ' ?'}"
          }],
          attrs: {
            "color": "error"
          }
        }, [_c('i', {
          staticClass: "fa fa-close",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir ")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
          attrs: {
            "color": "primary"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.detalharItem(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Detalhe ")])]
      }
    }, {
      key: "descricao",
      fn: function(row) {
        return [_vm._v("\n                    #" + _vm._s(row.item.id) + " " + _vm._s(row.value) + "\n                ")]
      }
    }, {
      key: "valorMedio",
      fn: function(row) {
        return [_vm._v("\n                    " + _vm._s(_vm._f("real")(row.value)) + "\n                ")]
      }
    }, {
      key: "CV",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row-flex all-centered gap-5",
          class: row.value > 25 ? 'cv-atencao' : 'cv-ok'
        }, [_c('i', {
          staticClass: "fa",
          class: row.value > 25 ? 'fa-exclamation-circle' : 'fa-thumbs-up'
        }), _vm._v(" " + _vm._s(row.value) + "%\n                  ")])]
      }
    }], null, false, 3674501315)
  })], 1) : _vm._e(), _vm._v(" "), (this.itensCotacao.length === 0) ? _c('b-container', {
    staticClass: "w-100",
    attrs: {
      "fluid": ""
    }
  }, [_c('label', [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v("  Orçamento Manual:\n                ")]), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.tableManual.bordered,
      "items": _vm.tableManual.items,
      "hover": _vm.tableManual.hover,
      "fields": _vm.tableManual.fields,
      "filter": _vm.tableManual.filter,
      "current-page": _vm.tableManual.currentPage,
      "per-page": _vm.tableManual.perPage,
      "sort-by": _vm.tableManual.sortBy,
      "sort-desc": _vm.tableManual.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tableManual, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tableManual, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tableManual, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tableManual, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [(!_vm.validandoCotacao) ? _c('g-button-ujarak', {
          directives: [{
            name: "confirm",
            rawName: "v-confirm",
            value: ({
              ok: function (retorno) { return _vm.removerItem(row.index, true); },
              cancel: _vm.doNothing,
              message: 'Confirma Exclusão do Produto/Serviço: ' + row.item.descricao + ' ?'
            }),
            expression: "{ok: retorno => removerItem(row.index, true), cancel: doNothing,\n                              message: 'Confirma Exclusão do Produto/Serviço: ' + row.item.descricao + ' ?'}"
          }],
          attrs: {
            "color": "error"
          }
        }, [_c('i', {
          staticClass: "fa fa-close",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir ")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
          attrs: {
            "color": "primary"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.detalharItemManual(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Detalhe ")])]
      }
    }, {
      key: "descricao",
      fn: function(row) {
        return [_vm._v("\n                    #" + _vm._s(row.item.id) + " " + _vm._s(row.value) + "\n                ")]
      }
    }, {
      key: "valorMedio",
      fn: function(row) {
        return [_vm._v("\n                    " + _vm._s(_vm._f("real")(row.value)) + "\n                ")]
      }
    }], null, false, 3587490646)
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column start-centered cotacao-status-container"
  }, [_c('div', [_vm._v("\n              Status: "), _c('b', [_vm._v(_vm._s(_vm.itemCotacaoValidado ? 'Validado' : 'Pendente de Validação'))]), _vm._v("  " + _vm._s(_vm.horaValidacao) + "\n            ")]), _vm._v(" "), (_vm.itemCotacaoResponsavelValidacao !== '' && !_vm._.isNull(_vm.itemCotacaoResponsavelValidacao)) ? _c('div', [_vm._v("\n              Responsável: "), _c('b', [_vm._v(_vm._s(_vm.itemCotacaoResponsavelValidacao))])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-between resumo-container"
  }, [_c('b', [_vm._v("Total:")]), _vm._v("  " + _vm._s(_vm._f("real")(_vm.totalItens)) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start w-100 gap-5 button-cotacao-container"
  }, [(!_vm.validandoCotacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarCotacao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar Cotação ")]) : _vm._e(), _vm._v(" "), (_vm.validandoCotacao && !_vm.itemCotacaoValidado && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.validarCotacao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Validar Cotação ")]) : _vm._e(), _vm._v(" "), (_vm.validandoCotacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Fechar ")]) : _vm._e(), _vm._v(" "), (!_vm.validandoCotacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "error"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.abrirCotacaoPrecos) ? _c('div', {
    staticClass: "box-body column centered-start cotacao-itens-container"
  }, [_c('cotacaoPrecos', {
    attrs: {
      "toggleAdicionarItem": _vm.toggleAdicionarItem,
      "adicionarItem": _vm.adicionarItem
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.abrirCotacaoManual) ? _c('div', {
    staticClass: "box-body column centered-start cotacao-itens-container"
  }, [_c('cotacaoManual', {
    attrs: {
      "toggleCotacaoManual": _vm.toggleCotacaoManual,
      "adicionarItemManual": _vm.adicionarItemManual,
      "visualizacao": _vm.visualizacaoManual,
      "itemVisualizacao": _vm.itemSelecionadoDetalhe
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.abrirDetalheItem) ? _c('div', {
    staticClass: "box-body column centered-start cotacao-itens-container"
  }, [_c('detalheItemCotacao', {
    attrs: {
      "itemCotacao": _vm.itemSelecionadoDetalhe,
      "toggleDetalharItem": _vm.toggleDetalharItem
    }
  })], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_c('i', {
    staticClass: "fa fa-cubes"
  }), _vm._v(" Itens cadastrados para cotação")]), _vm._v(" "), _c('div', [_vm._v("\n            *Caso o produto ou serviço tenha mais de um item contido nele, ex: '"), _c('i', [_vm._v("P1115/Ferramentas (pode ter uma furadeira, uma parafusadeira, etc.)")]), _vm._v("'\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Descrição da Cotação:")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-087de461!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/comparativoPrecos/cotacaoItens.vue
// module id = 1759
// module chunks = 2